module.exports = __webpack_public_path__ + "static/media/socle.95b6cab2.png";